import './styles';

import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export default class Lightbox extends React.Component {
	render() {
		return (
			<div className="Lightbox">
				<TransitionGroup>
					{this.props.visible ? (
						<CSSTransition
							classNames="Lightbox"
							timeout={{ enter: 750, exit: 750 }}
						>
							{this.content}
						</CSSTransition>
					) : null}
				</TransitionGroup>
			</div>
		);
	}

	get content() {
		return (
			<div>
				<div
					className="Lightbox-overlay"
					onClick={this.props.onClose}
				/>
				<div className="Lightbox-wrapper">
					<a
						className="Lightbox-close"
						onClick={this.props.onClose}
					></a>
					<div className="Lightbox-inner-wrapper">
						<div className="Lightbox-content">
							{this.props.children}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
